module.exports = __webpack_public_path__ + "static/media/wifi.bf90a108.svg";